/**
 * ============================================================
 *  FUSION DOLLS — COMPLETE UX ENHANCEMENT BUNDLE
 *  fusiondolls.com
 * ============================================================
 */

(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const qs = () => new URLSearchParams(window.location.search);

  function debounce(fn, ms = 300) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }

  function pushState(params) {
    const url = new URL(window.location.href);
    params.forEach((v, k) => v ? url.searchParams.set(k, v) : url.searchParams.delete(k));
    history.pushState({}, '', url);
  }

  /* ── 1. SEARCH UX ── */
  const Search = (() => {
    let dropdown = null;
    let activeIdx = -1;

    function init() {
      $$('form[action="/search"], [data-predictive-search-form]').forEach(wireForm);
      $$('input[name="q"][type="search"], input[name="q"][type="text"]').forEach(input => {
        if (!input.closest('form')) wireInput(input);
      });
      document.addEventListener('click', e => {
        if (dropdown && !dropdown.contains(e.target) && !e.target.closest('[name="q"]')) closeDropdown();
      });
    }

    function wireForm(form) {
      form.setAttribute('action', '/search');
      if (!form.querySelector('[name="type"]')) {
        const t = document.createElement('input');
        t.type = 'hidden'; t.name = 'type'; t.value = 'product';
        form.appendChild(t);
      }
      const input = form.querySelector('[name="q"]');
      if (input) wireInput(input, form);
      $$('[type="submit"], .search__button, .header__search-submit', form).forEach(btn => {
        btn.addEventListener('click', e => { e.preventDefault(); submitSearch(input ? input.value : ''); });
      });
      form.addEventListener('submit', e => { e.preventDefault(); submitSearch(input ? input.value : ''); });
    }

    function wireInput(input, form) {
      if (window.location.pathname === '/search') {
        const q = qs().get('q') || '';
        if (q && !input.value) input.value = q;
      }
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-haspopup', 'listbox');
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-expanded', 'false');
      input.addEventListener('input', debounce(e => onInput(e.target), 250));
      input.addEventListener('keydown', e => onKeydown(e, input));
      input.addEventListener('focus', () => { if (input.value.length >= 2) onInput(input); });
    }

    function onKeydown(e, input) {
      if (!dropdown) { if (e.key === 'Enter') { e.preventDefault(); submitSearch(input.value); } return; }
      const items = $$('[role="option"]', dropdown);
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, items.length - 1); setActive(items, activeIdx); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, -1); setActive(items, activeIdx); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        if (activeIdx >= 0 && items[activeIdx]) { const link = items[activeIdx].querySelector('a'); if (link) window.location.href = link.href; }
        else submitSearch(input.value);
      } else if (e.key === 'Escape') { closeDropdown(); input.blur(); }
    }

    function setActive(items, idx) {
      items.forEach((el, i) => { el.setAttribute('aria-selected', i === idx ? 'true' : 'false'); el.classList.toggle('fd-search__item--active', i === idx); });
    }

    async function onInput(input) {
      const q = input.value.trim();
      if (q.length < 2) { closeDropdown(); return; }
      showLoading(input);
      try {
        const res = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag');
        const data = await res.json();
        renderDropdown(input, q, (data && data.resources && data.resources.results && data.resources.results.products) || []);
      } catch(e) { closeDropdown(); }
    }

    function renderDropdown(input, q, products) {
      const rect = input.getBoundingClientRect();
      closeDropdown(false);
      activeIdx = -1;
      dropdown = document.createElement('div');
      dropdown.className = 'fd-search-dropdown';
      dropdown.setAttribute('role', 'listbox');
      dropdown.setAttribute('aria-label', 'Search suggestions');
      dropdown.style.cssText = 'position:fixed;top:' + (rect.bottom + window.scrollY + 4) + 'px;left:' + rect.left + 'px;width:' + Math.max(rect.width, 320) + 'px;z-index:99999;';
      if (!products.length) {
        dropdown.innerHTML = '<div class="fd-search__empty">No results for "<strong>' + q + '</strong>"</div>';
      } else {
        var items = products.map(function(p, i) {
          var price = p.price ? '$' + (p.price / 100).toFixed(2) : '';
          var img = (p.featured_image && p.featured_image.url) ? '<img src="' + p.featured_image.url + '&width=60" alt="' + p.title + '" width="50" height="50" loading="lazy">' : '<div class="fd-search__no-img">🪆</div>';
          return '<div class="fd-search__item" role="option" aria-selected="false"><a href="' + p.url + '" class="fd-search__item-link"><span class="fd-search__img">' + img + '</span><span class="fd-search__info"><span class="fd-search__title">' + highlight(p.title, q) + '</span>' + (p.product_type ? '<span class="fd-search__type">' + p.product_type + '</span>' : '') + '</span>' + (price ? '<span class="fd-search__price">' + price + '</span>' : '') + '</a></div>';
        }).join('');
        dropdown.innerHTML = items + '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="fd-search__view-all">🔍 View all results for "<strong>' + q + '</strong>"</a>';
      }
      var closeBtn = document.createElement('button');
      closeBtn.className = 'fd-search__close';
      closeBtn.setAttribute('aria-label', 'Close search suggestions');
      closeBtn.innerHTML = '✕';
      closeBtn.onclick = function() { closeDropdown(); };
      dropdown.appendChild(closeBtn);
      document.body.appendChild(dropdown);
      input.setAttribute('aria-expanded', 'true');
      var reposition = function() {
        var r = input.getBoundingClientRect();
        if (dropdown) { dropdown.style.top = (r.bottom + window.scrollY + 4) + 'px'; dropdown.style.left = r.left + 'px'; dropdown.style.width = Math.max(r.width, 320) + 'px'; }
      };
      window.addEventListener('resize', reposition);
      dropdown._cleanup = function() { window.removeEventListener('resize', reposition); };
    }

    function showLoading(input) {
      closeDropdown(false);
      var rect = input.getBoundingClientRect();
      dropdown = document.createElement('div');
      dropdown.className = 'fd-search-dropdown fd-search-dropdown--loading';
      dropdown.style.cssText = 'position:fixed;top:' + (rect.bottom + window.scrollY + 4) + 'px;left:' + rect.left + 'px;width:' + Math.max(rect.width, 320) + 'px;z-index:99999;';
      dropdown.innerHTML = '<div class="fd-search__loading"><span class="fd-spinner"></span> Searching…</div>';
      document.body.appendChild(dropdown);
    }

    function closeDropdown(cleanup) {
      if (cleanup === undefined) cleanup = true;
      if (dropdown) {
        if (dropdown._cleanup) dropdown._cleanup();
        dropdown.remove(); dropdown = null; activeIdx = -1;
        $$('[name="q"]').forEach(function(i) { i.setAttribute('aria-expanded', 'false'); });
      }
    }

    function submitSearch(q) {
      if (!q.trim()) return;
      window.location.href = '/search?q=' + encodeURIComponent(q.trim()) + '&type=product';
    }

    function highlight(text, q) {
      var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      return text.replace(re, '<mark>$1</mark>');
    }

    return { init: init };
  })();

  /* ── 2. FILTERS + SORT ── */
  const Filters = (() => {
    function init() {
      if (!/\/(collections|search)/.test(window.location.pathname)) return;
      enhanceSortBar();
      enhanceFilterPanel();
      initLoadMore();
      restoreScrollPosition();
    }

    function enhanceSortBar() {
      var sortSel = $('select#SortBy, select[name="sort_by"], .collection-sort select');
      if (!sortSel) return;
      var urlSort = qs().get('sort_by');
      if (urlSort) sortSel.value = urlSort;
      sortSel.addEventListener('change', function() {
        pushState(new Map([['sort_by', sortSel.value], ['page', '']]));
        window.location.href = window.location.href;
      });
    }

    function enhanceFilterPanel() {
      var params = qs();
      var hasFilters = false;
      params.forEach(function(v, k) { if (k.startsWith('filter.')) hasFilters = true; });
      if (!hasFilters) return;
      var filterForm = $('form#FacetFiltersForm, form.facets-form, [data-filter-form]');
      if (!filterForm) return;
      var clearBtn = document.createElement('button');
      clearBtn.className = 'fd-filter__clear-all';
      clearBtn.textContent = '✕ Clear all filters';
      clearBtn.type = 'button';
      clearBtn.onclick = function() {
        var url = new URL(window.location.href);
        var toDelete = [];
        url.searchParams.forEach(function(v, k) { if (k.startsWith('filter.')) toDelete.push(k); });
        toDelete.forEach(function(k) { url.searchParams.delete(k); });
        url.searchParams.delete('page');
        window.location.href = url.toString();
      };
      filterForm.prepend(clearBtn);
      var mobileToggle = $('[data-filter-toggle], .facets__toggle, button[aria-controls*="filter"]');
      if (mobileToggle) {
        var count = 0;
        params.forEach(function(v, k) { if (k.startsWith('filter.')) count++; });
        if (count) {
          var badge = document.createElement('span');
          badge.className = 'fd-filter__badge';
          badge.textContent = count;
          mobileToggle.appendChild(badge);
        }
      }
    }

    function initLoadMore() {
      var pagination = $('.pagination, [data-pagination]');
      if (!pagination) return;
      var nextLink = $('a[rel="next"], .pagination__next a', pagination);
      if (!nextLink) {
        var links = $$('a', pagination);
        for (var i = 0; i < links.length; i++) {
          if (links[i].textContent.includes('Next') || links[i].rel === 'next') { nextLink = links[i]; break; }
        }
      }
      if (!nextLink) return;
      var btn = document.createElement('button');
      btn.className = 'fd-load-more';
      btn.textContent = 'Load More Products';
      btn.setAttribute('aria-label', 'Load more products');
      btn.dataset.href = nextLink.href;
      btn.addEventListener('click', async function() {
        btn.disabled = true;
        btn.innerHTML = '<span class="fd-spinner"></span> Loading…';
        try {
          var html = await fetch(btn.dataset.href).then(function(r) { return r.text(); });
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newProducts = $$('.product-grid .grid__item, .collection-product-list .product-item, ul.product-grid > li', doc);
          var grid = $('.product-grid, .collection-product-list, ul.product-grid');
          if (grid && newProducts.length) {
            var firstNew = newProducts[0];
            newProducts.forEach(function(p) { grid.appendChild(p); });
            QuickView.bindCards(newProducts);
            Wishlist.bindCards(newProducts);
            firstNew.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          var newNext = $('a[rel="next"], .pagination__next a', doc);
          if (newNext) {
            btn.dataset.href = newNext.href;
            btn.disabled = false;
            btn.textContent = 'Load More Products';
            pushState(new Map([['page', (parseInt(new URL(newNext.href).searchParams.get('page')) - 1).toString() || '']]));
          } else {
            btn.textContent = '✓ All products loaded';
            btn.disabled = true;
          }
        } catch(e) {
          btn.textContent = 'Load More Products';
          btn.disabled = false;
        }
      });
      pagination.replaceChildren(btn);
    }

    function restoreScrollPosition() {
      $$('a[href*="/products/"]').forEach(function(a) {
        a.addEventListener('click', function() {
          sessionStorage.setItem('fd_scroll', window.scrollY);
          sessionStorage.setItem('fd_scroll_url', window.location.href);
        });
      });
      var savedUrl = sessionStorage.getItem('fd_scroll_url');
      var savedScroll = sessionStorage.getItem('fd_scroll');
      if (savedScroll && savedUrl === window.location.href) {
        requestAnimationFrame(function() { window.scrollTo(0, parseInt(savedScroll)); });
        sessionStorage.removeItem('fd_scroll');
        sessionStorage.removeItem('fd_scroll_url');
      }
    }
    return { init: init };
  })();

  /* ── 3. PAGINATION ── */
  const Pagination = (() => {
    function init() {
      var pagination = $('.pagination');
      if (!pagination) return;
      var currentPage = parseInt(qs().get('page') || '1');
      $$('a', pagination).forEach(function(a) {
        var pageNum = parseInt(new URL(a.href).searchParams.get('page') || '1');
        if (pageNum === currentPage) { a.classList.add('fd-pagination__active'); a.setAttribute('aria-current', 'page'); }
        a.addEventListener('click', function() { pushState(new Map([['page', pageNum.toString()]])); });
      });
    }
    return { init: init };
  })();

  /* ── 4. QUICK VIEW ── */
  const QuickView = (() => {
    let modal = null;
    function init() { bindCards($$('.grid__item, .product-item, [data-product-card]')); }
    function bindCards(cards) {
      cards.forEach(function(card) {
        var link = $('a[href*="/products/"]', card);
        if (!link || card.dataset.fdQvBound) return;
        card.dataset.fdQvBound = '1';
        var qvBtn = $('.fd-qv-btn', card);
        if (!qvBtn) {
          qvBtn = document.createElement('button');
          qvBtn.className = 'fd-qv-btn';
          qvBtn.setAttribute('aria-label', 'Quick view');
          qvBtn.innerHTML = '⚡ Quick View';
          var imgWrap = $('a, .card__media, .product-card__image', card);
          if (imgWrap) imgWrap.appendChild(qvBtn); else card.appendChild(qvBtn);
        }
        qvBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); openModal(link.href); });
      });
    }
    async function openModal(url) {
      closeModal();
      modal = document.createElement('div');
      modal.className = 'fd-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Quick view');
      modal.innerHTML = '<div class="fd-modal__backdrop"></div><div class="fd-modal__box"><button class="fd-modal__close" aria-label="Close quick view">✕</button><div class="fd-modal__body fd-modal__body--loading"><span class="fd-spinner fd-spinner--lg"></span></div></div>';
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
      $('.fd-modal__backdrop', modal).onclick = closeModal;
      $('.fd-modal__close', modal).onclick = closeModal;
      document.addEventListener('keydown', escClose);
      try {
        var html = await fetch(url).then(function(r) { return r.text(); });
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Remove header, nav, footer, scripts so their text doesn't leak in
        $$('header, nav, footer, script, style, .site-header, .header-navigation, .search-bar, form[action="/search"], [data-section-type="header"]', doc).forEach(function(el) { el.remove(); });

        // Title — try multiple selectors specific to this theme
        var titleEl = $('h1.product-detail__title, h1.product__title, h1[itemprop="name"], .product-detail__title, #MainContent h1', doc);
        var title = titleEl ? titleEl.textContent.trim() : '';

        // Price
        var priceEl = $('.product-detail__price .theme-money, .product__price .theme-money, [data-product-price] .theme-money, .price .theme-money', doc);
        var price = priceEl ? priceEl.textContent.trim() : '';

        // Images — get from product media section only
        var imgs = $$('.product-detail__images img, .product-single__photo img, .product__media img', doc).slice(0, 3);

        // Description
        var descEl = $('#tab1.rte, .product-detail .rte, .product__description', doc);
        var desc = descEl ? descEl.innerHTML : '';

        // Variant ID for add to cart
        var idInput = $('[name="id"]', doc);
        var productUrl = url.split('?')[0];

        var imgHtml = imgs.length
          ? '<div class="fd-qv__images">' + imgs.map(function(i) { return '<img src="' + i.src + '" alt="' + (i.alt || title) + '" loading="lazy">'; }).join('') + '</div>'
          : '';

        var body = modal.querySelector('.fd-modal__body');
        body.className = 'fd-modal__body';
        body.innerHTML = imgHtml +
          '<div class="fd-qv__info">' +
            '<h2 class="fd-qv__title">' + (title || 'View Product') + '</h2>' +
            '<p class="fd-qv__price">' + price + '</p>' +
            '<div class="fd-qv__actions">' +
              '<form action="/cart/add" method="post" class="fd-qv__form">' +
                '<input type="hidden" name="id" value="' + (idInput ? idInput.value : '') + '">' +
                '<input type="hidden" name="quantity" value="1">' +
                '<button type="submit" class="fd-btn fd-btn--primary">Add to Cart</button>' +
              '</form>' +
              '<a href="' + productUrl + '" class="fd-btn fd-btn--ghost">View Full Details →</a>' +
            '</div>' +
            '<div class="fd-qv__desc">' + desc.substring(0, 400) + (desc.length > 400 ? '…' : '') + '</div>' +
          '</div>';

        var qvForm = body.querySelector('.fd-qv__form');
        if (qvForm) qvForm.addEventListener('submit', async function(e) {
          e.preventDefault();
          var submitBtn = e.target.querySelector('[type="submit"]');
          submitBtn.disabled = true; submitBtn.textContent = 'Adding…';
          await fetch('/cart/add.js', { method: 'POST', body: new FormData(e.target) });
          submitBtn.textContent = '✓ Added!';
          setTimeout(function() { closeModal(); }, 900);
          var cartData = await fetch('/cart.js').then(function(r) { return r.json(); });
          $$('.cart-count, [data-cart-count], .header-cart__count').forEach(function(el) { el.textContent = cartData.item_count; });
        });
      } catch(e) {
        var body2 = modal.querySelector('.fd-modal__body');
        if (body2) body2.innerHTML = '<p class="fd-modal__error">Could not load product. <a href="' + url + '">View full page →</a></p>';
      }
    }
    function closeModal() { if (modal) { modal.remove(); modal = null; document.body.style.overflow = ''; } document.removeEventListener('keydown', escClose); }
    function escClose(e) { if (e.key === 'Escape') closeModal(); }
    return { init: init, bindCards: bindCards };
  })();

  /* ── COMPARE ── */
  const Compare = (() => {
    const MAX = 3;
    let bar = null;
    let selected = JSON.parse(sessionStorage.getItem('fd_compare') || '[]');
    function init() { bindCards($$('.grid__item, .product-item, [data-product-card]')); if (selected.length) renderBar(); }
    function bindCards(cards) {
      cards.forEach(function(card) {
        if (card.dataset.fdCmpBound) return;
        card.dataset.fdCmpBound = '1';
        var link = $('a[href*="/products/"]', card);
        if (!link) return;
        var title = ($('h2, h3, .card__heading a', card) || {textContent:''}).textContent.trim() || 'Product';
        var handle = link.href.split('/products/')[1] ? link.href.split('/products/')[1].split('?')[0] : '';
        var btn = document.createElement('button');
        btn.className = 'fd-compare-btn';
        var isSel = selected.some(function(s) { return s.handle === handle; });
        btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
        btn.textContent = isSel ? '✓ Comparing' : '+ Compare';
        card.appendChild(btn);
        btn.addEventListener('click', function() { toggle({ handle: handle, title: title, url: link.href }, btn); });
      });
    }
    function toggle(item, btn) {
      var idx = selected.findIndex(function(s) { return s.handle === item.handle; });
      if (idx >= 0) { selected.splice(idx, 1); btn.textContent = '+ Compare'; btn.setAttribute('aria-pressed', 'false'); }
      else { if (selected.length >= MAX) { alert('You can compare up to ' + MAX + ' products.'); return; } selected.push(item); btn.textContent = '✓ Comparing'; btn.setAttribute('aria-pressed', 'true'); }
      sessionStorage.setItem('fd_compare', JSON.stringify(selected));
      renderBar();
    }
    function renderBar() {
      if (bar) bar.remove();
      if (!selected.length) return;
      bar = document.createElement('div');
      bar.className = 'fd-compare-bar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Compare products');
      bar.innerHTML = '<span class="fd-compare-bar__label">Compare (' + selected.length + '/' + MAX + ')</span><div class="fd-compare-bar__items">' + selected.map(function(s) { return '<span class="fd-compare-bar__item">' + s.title.substring(0, 20) + '…<button data-handle="' + s.handle + '" aria-label="Remove ' + s.title + '">✕</button></span>'; }).join('') + '</div><button class="fd-btn fd-btn--primary fd-compare-bar__go"' + (selected.length < 2 ? ' disabled' : '') + '>Compare ' + selected.length + ' Items</button><button class="fd-compare-bar__clear">Clear</button>';
      $$('[data-handle]', bar).forEach(function(b) {
        b.addEventListener('click', function() {
          var h = b.dataset.handle;
          selected = selected.filter(function(s) { return s.handle !== h; });
          sessionStorage.setItem('fd_compare', JSON.stringify(selected));
          renderBar();
        });
      });
      bar.querySelector('.fd-compare-bar__clear').onclick = function() {
        selected = []; sessionStorage.removeItem('fd_compare');
        $$('.fd-compare-btn').forEach(function(b) { b.textContent = '+ Compare'; b.setAttribute('aria-pressed', 'false'); });
        renderBar();
      };
      bar.querySelector('.fd-compare-bar__go').onclick = function() { if (selected.length >= 2) openCompareModal(); };
      document.body.appendChild(bar);
    }
    async function openCompareModal() {
      var modal = document.createElement('div');
      modal.className = 'fd-modal fd-modal--compare';
      modal.innerHTML = '<div class="fd-modal__backdrop"></div><div class="fd-modal__box fd-modal__box--wide"><button class="fd-modal__close" aria-label="Close compare">✕</button><h2 class="fd-modal__title">Compare Products</h2><div class="fd-compare__grid fd-modal__body--loading"><span class="fd-spinner fd-spinner--lg"></span></div></div>';
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
      modal.querySelector('.fd-modal__backdrop').onclick = function() { modal.remove(); document.body.style.overflow = ''; };
      modal.querySelector('.fd-modal__close').onclick = function() { modal.remove(); document.body.style.overflow = ''; };
      var pages = await Promise.all(selected.map(function(s) { return fetch(s.url).then(function(r) { return r.text(); }); }));
      var products = pages.map(function(html, i) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        $$('header, nav, footer, script, style', doc).forEach(function(el) { el.remove(); });
        return { title: selected[i].title, price: ($('.product-detail__price .theme-money, [data-product-price] .theme-money', doc) || {textContent:'—'}).textContent.trim(), img: ($('img.product__media-img, .product-detail__images img', doc) || {src:''}).src, type: ($('[itemprop="category"], .product-type', doc) || {textContent:'—'}).textContent.trim(), desc: (($('#tab1.rte, .product__description', doc) || {textContent:'—'}).textContent.trim()).substring(0, 150), url: selected[i].url };
      });
      var grid = modal.querySelector('.fd-compare__grid');
      grid.className = 'fd-compare__grid';
      grid.innerHTML = '<div style="overflow-x:auto"><table class="fd-compare__table"><tr>' + products.map(function(p) { return '<th><img src="' + p.img + '" alt="' + p.title + '"><a href="' + p.url + '">' + p.title + '</a></th>'; }).join('') + '</tr><tr><td colspan="' + products.length + '" class="fd-compare__row-label">Price</td></tr><tr>' + products.map(function(p) { return '<td>' + p.price + '</td>'; }).join('') + '</tr><tr><td colspan="' + products.length + '" class="fd-compare__row-label">Type</td></tr><tr>' + products.map(function(p) { return '<td>' + p.type + '</td>'; }).join('') + '</tr><tr>' + products.map(function(p) { return '<td><a href="' + p.url + '" class="fd-btn fd-btn--primary">View Product</a></td>'; }).join('') + '</tr></table></div>';
    }
    return { init: init, bindCards: bindCards };
  })();

  /* ── WISHLIST ── */
  const Wishlist = (() => {
    let list = JSON.parse(localStorage.getItem('fd_wishlist') || '[]');
    function init() { bindCards($$('.grid__item, .product-item, [data-product-card]')); injectWishlistNav(); }
    function bindCards(cards) {
      cards.forEach(function(card) {
        if (card.dataset.fdWlBound) return;
        card.dataset.fdWlBound = '1';
        var link = $('a[href*="/products/"]', card);
        if (!link) return;
        var handle = link.href.split('/products/')[1] ? link.href.split('/products/')[1].split('?')[0] : '';
        var title = ($('h2, h3, .card__heading a', card) || {textContent:''}).textContent.trim();
        var img = (card.querySelector('img') || {src:''}).src;
        var price = ($('[class*="price"]', card) || {textContent:''}).textContent.trim();
        var saved = list.some(function(i) { return i.handle === handle; });
        var btn = document.createElement('button');
        btn.className = 'fd-wishlist-btn' + (saved ? ' fd-wishlist-btn--saved' : '');
        btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        btn.innerHTML = saved ? '❤️' : '🤍';
        card.appendChild(btn);
        btn.addEventListener('click', function(e) { e.preventDefault(); toggle({ handle: handle, title: title, img: img, price: price, url: link.href }, btn); });
      });
    }
    function toggle(item, btn) {
      var idx = list.findIndex(function(i) { return i.handle === item.handle; });
      if (idx >= 0) { list.splice(idx, 1); btn.innerHTML = '🤍'; btn.classList.remove('fd-wishlist-btn--saved'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Save to wishlist'); }
      else { list.push(item); btn.innerHTML = '❤️'; btn.classList.add('fd-wishlist-btn--saved'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Remove from wishlist'); }
      localStorage.setItem('fd_wishlist', JSON.stringify(list));
      updateNavCount();
    }
    function injectWishlistNav() {
      var nav = $('.header__icons, .site-nav__icons, [class*="header-icons"]');
      if (!nav || nav.querySelector('.fd-wishlist-nav')) return;
      var a = document.createElement('a');
      a.href = '#wishlist'; a.className = 'fd-wishlist-nav';
      a.setAttribute('aria-label', 'Wishlist (' + list.length + ' items)');
      a.innerHTML = '❤️ <span class="fd-wishlist-nav__count">' + (list.length || '') + '</span>';
      a.onclick = function(e) { e.preventDefault(); openWishlistDrawer(); };
      nav.appendChild(a);
    }
    function updateNavCount() { var c = $('.fd-wishlist-nav__count'); if (c) c.textContent = list.length || ''; }
    function openWishlistDrawer() {
      var existing = $('.fd-wishlist-drawer');
      if (existing) existing.remove();
      var drawer = document.createElement('div');
      drawer.className = 'fd-wishlist-drawer';
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-label', 'Wishlist');
      drawer.innerHTML = '<div class="fd-wishlist-drawer__header"><h2>My Wishlist (' + list.length + ')</h2><button class="fd-modal__close" aria-label="Close wishlist">✕</button></div><div class="fd-wishlist-drawer__body">' + (!list.length ? '<p class="fd-wishlist-drawer__empty">No saved items yet. Click 🤍 on any product!</p>' : list.map(function(item) { return '<div class="fd-wishlist-item"><a href="' + item.url + '"><img src="' + item.img + '" alt="' + item.title + '" width="70" height="70"></a><div class="fd-wishlist-item__info"><a href="' + item.url + '">' + item.title + '</a><span>' + item.price + '</span></div><button class="fd-wishlist-item__remove" data-handle="' + item.handle + '" aria-label="Remove">✕</button></div>'; }).join('')) + '</div>';
      document.body.appendChild(drawer);
      requestAnimationFrame(function() { drawer.classList.add('fd-wishlist-drawer--open'); });
      drawer.querySelector('.fd-modal__close').onclick = function() { drawer.classList.remove('fd-wishlist-drawer--open'); setTimeout(function() { drawer.remove(); }, 300); };
      $$('.fd-wishlist-item__remove', drawer).forEach(function(btn) {
        btn.onclick = function() {
          var h = btn.dataset.handle;
          var i = list.findIndex(function(x) { return x.handle === h; });
          if (i >= 0) list.splice(i, 1);
          localStorage.setItem('fd_wishlist', JSON.stringify(list));
          updateNavCount();
          openWishlistDrawer();
        };
      });
    }
    return { init: init, bindCards: bindCards };
  })();

  /* ── 5. SEARCH RESULTS ── */
  const SearchResults = (() => {
    function init() {
      if (window.location.pathname !== '/search') return;
      var q = qs().get('q') || '';
      $$('input[name="q"]').forEach(function(i) { if (!i.value) i.value = q; });
      var heading = $('h1, .search__title, [class*="search-title"]');
      if (heading && q) {
        var count = (($('[data-results-count]') || $('[class*="results-count"]') || {textContent:''}).textContent) || $$('.product-item, .grid__item').length;
        heading.insertAdjacentHTML('afterend', '<p class="fd-search__results-count">Showing <strong>' + count + '</strong> results for "<em>' + q + '</em>"</p>');
      }
      if (!$('.fd-search-sort')) {
        var grid = $('.product-grid, [class*="search-results"]');
        if (grid) {
          var currentSort = qs().get('sort_by') || 'relevance';
          var sortBar = document.createElement('div');
          sortBar.className = 'fd-search-sort';
          sortBar.innerHTML = '<label for="fd-sort-select">Sort by:</label><select id="fd-sort-select"><option value="relevance"' + (currentSort==='relevance'?' selected':'') + '>Most Relevant</option><option value="price-ascending"' + (currentSort==='price-ascending'?' selected':'') + '>Price: Low to High</option><option value="price-descending"' + (currentSort==='price-descending'?' selected':'') + '>Price: High to Low</option><option value="created-descending"' + (currentSort==='created-descending'?' selected':'') + '>Newest First</option><option value="title-ascending"' + (currentSort==='title-ascending'?' selected':'') + '>A–Z</option></select>';
          grid.before(sortBar);
          document.getElementById('fd-sort-select').addEventListener('change', function(e) {
            pushState(new Map([['sort_by', e.target.value]]));
            window.location.href = window.location.href;
          });
        }
      }
    }
    return { init: init };
  })();

  /* ── COOKIE BANNER FIX ── */
  function fixCookieBanner() {
    new MutationObserver(function() {
      $$('[class*="cookie"],[id*="cookie"],[class*="consent"],[id*="consent"]').forEach(function(el) {
        el.style.zIndex = '9000'; el.style.bottom = '0'; el.style.top = 'auto';
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ── BOOT ── */
  function boot() {
    Search.init(); Filters.init(); Pagination.init();
    QuickView.init(); Compare.init(); Wishlist.init();
    SearchResults.init(); fixCookieBanner();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

})();
